import React, { Suspense, useEffect } from "react";
import {
    BrowserRouter as Router,
    Route,
    Switch,
    useHistory,
} from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import ThemeComponent from "../components/ThemeComponent/ThemeComponent";
import Spinner from "../components/Spinner/Spinner";
import { closeAllOpenModals } from "../hooks/useMobileBackClose";

const PageLayout = React.lazy(() => import("../layouts/PageLayout"));
const Laporan = React.lazy(() => import("../pages/Laporan/Laporan"));
const Shifting = React.lazy(() => import("../pages/Shifting/Shifting"));
const LoginPage = React.lazy(() => import("../pages/LoginPage/LoginPage"));
const StokBarang = React.lazy(() => import("../pages/StokBarang/StokBarang"));
const Transaksi = React.lazy(() => import("../pages/Transaksi/Transaksi"));
const Pengaturan = React.lazy(() => import("../pages/Pengaturan/Pengaturan"));
const RegisterPage = React.lazy(() => import("../pages/RegisterPage/RegisterPage"));
const BuatTokoPage = React.lazy(() => import("../pages/BuatTokoPage/BuatTokoPage"));
const VerifikasiEmailPage = React.lazy(
    () => import("../pages/VerifikasiEmailPage/VerifikasiEmailPage"),
);
const ResetPassword = React.lazy(() => import("../pages/ResetPassword/ResetPassword"));
const Halaman404 = React.lazy(() => import("../pages/Halaman404/Halaman404"));
const HalamanStruk = React.lazy(() => import("../pages/HalamanStruk/HalamanStruk"));
const PaymentInfoPage = React.lazy(() => import("../pages/Payment/PaymentInfoPage"));
const PaymentMethodPage = React.lazy(
    () => import("../pages/Payment/PaymentMethodPage"),
);
const PaymentVAPage = React.lazy(() => import("../pages/Payment/PaymentVAPage"));
const StatusError = React.lazy(() => import("../pages/Payment/StatusError"));
const StatusSuccess = React.lazy(() => import("../pages/Payment/StatusSuccess"));
const SyaratKetentuanPage = React.lazy(
    () => import("../pages/SyaratKetentuanPage/SyaratKetentuanPage"),
);
const BahanBaku = React.lazy(() => import("../pages/BahanBaku/BahanBaku"));

const RouteLoadingFallback = () => (
    <div
        role="status"
        aria-live="polite"
        style={{ minHeight: "100dvh", position: "relative" }}
    >
        <Spinner />
    </div>
);

function CloseModalsOnRouteChange() {
    const history = useHistory();
    useEffect(() => {
        let previousPathname = history.location.pathname;
        const unlisten = history.listen((location, action) => {
            if (action !== "POP" && location.pathname !== previousPathname) {
                closeAllOpenModals();
            }
            previousPathname = location.pathname;
        });
        return () => unlisten();
    }, [history]);
    return null;
}

export default function Routes() {
    return (
        <Router>
            <CloseModalsOnRouteChange />
            <Suspense fallback={<RouteLoadingFallback />}>
                <Switch>
                    <PrivateRoute path="/pengaturan">
                        <ThemeComponent>
                            <PageLayout>
                                <Pengaturan />
                            </PageLayout>
                        </ThemeComponent>
                    </PrivateRoute>
                    <PrivateRoute path="/transaksi">
                        <ThemeComponent>
                            <PageLayout>
                                <Transaksi />
                            </PageLayout>
                        </ThemeComponent>
                    </PrivateRoute>
                    <PrivateRoute path="/stok">
                        <ThemeComponent>
                            <PageLayout>
                                <StokBarang />
                            </PageLayout>
                        </ThemeComponent>
                    </PrivateRoute>
                    <PrivateRoute path="/bahan-dan-resep">
                        <ThemeComponent>
                            <PageLayout>
                                <BahanBaku />
                            </PageLayout>
                        </ThemeComponent>
                    </PrivateRoute>
                    <PrivateRoute path="/laporan">
                        <ThemeComponent>
                            <PageLayout>
                                <Laporan />
                            </PageLayout>
                        </ThemeComponent>
                    </PrivateRoute>
                    <PrivateRoute path="/shift">
                        <ThemeComponent>
                            <PageLayout>
                                <Shifting />
                            </PageLayout>
                        </ThemeComponent>
                    </PrivateRoute>
                    <PrivateRoute path="/buat-ukm">
                        <BuatTokoPage />
                    </PrivateRoute>
                    <PublicRoute path="/" exact>
                        <LoginPage />
                    </PublicRoute>
                    <PublicRoute path="/registrasi">
                        <RegisterPage />
                    </PublicRoute>
                    <PublicRoute path="/verifikasi">
                        <VerifikasiEmailPage />
                    </PublicRoute>
                    <PublicRoute path="/syarat-ketentuan">
                        <SyaratKetentuanPage />
                    </PublicRoute>
                    <Route path="/atur-kata-sandi">
                        <ResetPassword />
                    </Route>
                    <Route path="/struk/:slug">
                        <HalamanStruk />
                    </Route>
                    <Route path="/payment/:orderId/:layananId/:ukmId" exact>
                        <PaymentInfoPage />
                    </Route>
                    <Route path="/payment/:orderId/:layananId/:ukmId/metode" exact>
                        <PaymentMethodPage />
                    </Route>
                    <Route
                        path="/payment/:orderId/:layananId/:ukmId/metode/:type"
                        exact
                    >
                        <PaymentVAPage />
                    </Route>
                    <Route path="/payment/error">
                        <StatusError />
                    </Route>
                    <Route path="/payment/success">
                        <StatusSuccess />
                    </Route>
                    <Route path="*">
                        <Halaman404 />
                    </Route>
                </Switch>
            </Suspense>
        </Router>
    );
}
